<template>
    <div 
        v-if="user" 
        id="user" 
        class="box box-primary">
        <div class="box-header with-border">
            <h3 class="box-title">Nastavitve</h3>
        </div>
        <form 
            role="form" 
            @submit.prevent="submit">
            <div class="box-body">
                <div class="form-group">
                    <label for="email">E-poštni naslov</label>
                    <input 
                        id="email"
                        v-model="user.email"
                        :readonly="!admin"
                        :required="admin"
                        type="email"
                        class="form-control"
                        name="email"
                        placeholder="E-poštni naslov">
                </div>
                <div class="form-group">
                    <label for="password">Geslo</label>
                    <input 
                        id="password"
                        :pattern="'.{' + minimum_password_length + ',}'"
                        v-model="password"
                        type="password"
                        class="form-control"
                        name="password"
                        placeholder="Geslo">
                </div>
                <div class="form-group">
                    <label for="password_confirmation">Ponovi geslo</label>
                    <input 
                        id="password_confirmation"
                        :pattern="'.{' + minimum_password_length + ',}'"
                        v-model="passwordConfirmation"
                        type="password"
                        class="form-control"
                        name="password_confirmation"
                        placeholder="Ponovi geslo">
                </div>
            </div>
            <div class="box-footer">
                <button 
                    type="submit" 
                    class="btn btn-primary">Posodobi</button>
            </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'User',

    props: {
        api_route:               {
            type:     String,
            required: true
        },
        user_id:                 {
            required: true,
            type:     Number
        },
        minimum_password_length: {
            default: 6,
            type:    Number
        },
        admin:                   {
            type:    Boolean,
            defualt: false
        }
    },

    data() {
        return {
            submitting:           false,
            user:                 {},
            password:             null,
            passwordConfirmation: null
        };
    },

    created() {
        this.getUserData();
    },

    methods: {
        prepareUpdateData() {
            let data = (({email}) => ({email}))(this.user);

            if (this.password && this.password.length) {
                if (this.password === this.passwordConfirmation) {
                    data['password'] = this.password;
                    data['password_confirm'] = this.passwordConfirmation;
                } else {
                    this.$toast.error({
                        title:   'NAPAKA!',
                        message: 'Gesli se morata ujemati!',
                        timeOut: 10000
                    });

                    return {};
                }
            }

            return data;
        },

        getUserData() {
            axios.get(`${this.api_route}/${this.user_id}`)
                .then(response => {
                    this.$set(this, 'user', response.data.data);
                })
                .catch(error => {
                    this.$set(this, 'submitting', false);

                    if ('errors' in error.response.data && error.response.data.errors) {
                        for (let field in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(field)) {
                                this.$toast.error({
                                    title:   'NAPAKA!',
                                    message: error.response.data.errors[field][0],
                                    timeOut: 10000
                                });
                            }
                        }
                    }
                });
        },

        submit() {
            if (this.submitting)
                return;

            let data = this.prepareUpdateData();

            if (Object.keys(data).length === 0)
                return;

            this.$set(this, 'submitting', true);

            axios.put(`${this.api_route}/${this.user_id}`, data)
                .then(response => {
                    this.$set(this, 'submitting', false);

                    this.$toast.success({
                        title:   'USPEH!',
                        message: response.data.message
                    });
                })
                .catch(error => {
                    this.$set(this, 'submitting', false);

                    if ('errors' in error.response.data && error.response.data.errors) {
                        for (let field in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(field)) {
                                this.$toast.error({
                                    title:   'NAPAKA!',
                                    message: error.response.data.errors[field][0],
                                    timeOut: 10000
                                });
                            }
                        }
                    }
                });
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Users/User.vue